
import React from 'react';
import { DatabaseTableSortOrder, TablesByTagQuery, TablesByTagQueryVariables, TablesDisplayGridRowDataFragment, TablesQuery, TablesQueryVariables , TablesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { TablesDisplayGrid } from '../sharedDisplayGrid/TablesDisplayGrid';
import { TablesValidSortFields } from '../sorting/sortProviders/TablesGridSortProvider';
import { getRowDataWithMaxCountsForTable } from '../table/functions/TableRowDataFunctions';
import { TablesDisplayGridRowData } from '../table/types/TablesDisplayGridRowData';

export type QueryVariables = TablesQueryVariables;
export type QueryResults = TablesQuery;
export type QueryResultListNode = TablesDisplayGridRowDataFragment;

export type QueryVariablesWithTagFilter = TablesByTagQueryVariables;
export type QueryResultsWithTagFilter = TablesByTagQuery;
export type QueryResultListNodeWithTagFilter = TablesDisplayGridRowDataFragment;

export type GridRowData = TablesDisplayGridRowData;

export function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databaseTablesConnection;
}

export function selectConnectionListResultWithTagFilter(
  resultData: QueryResultsWithTagFilter
): ConnectionListResult<QueryResultListNodeWithTagFilter> | null {
  return resultData && resultData.tags && resultData.tags[0].databaseTablesConnection;
}

export type TablesExplorerQueryGridProps = GridSortProps<TablesValidSortFields>;

// This component is used only from the example. In the actual app, we render the Tables Explorer via VizPortal's "Explorer" instead,
// using these result mappers and the columns from the TablesDisplayGrid.
export function TablesExplorerQueryGrid(props: TablesExplorerQueryGridProps): JSX.Element {
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TablesDocument}
      partialQueryVariables={{
        orderBy: props.orderBy as DatabaseTableSortOrder,
        hasActiveWarning: null,
        isCertified: null,
        textSearch: null,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataWithMaxCountsForTable}
    >
      {({ rowStore }) => (
        <TablesDisplayGrid
          rowStore={rowStore}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
